import PropTypes from 'prop-types';

const ButtonBase = {};

ButtonBase.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  openInNewTab: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ButtonBase;
